<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item   label="身份证号：">
              <el-input   v-model="form.idCard" 
                    placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('gyxgwaztjb')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._d"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/公益性岗位安置统计表--导入.xls" download="公益性岗位安置统计表.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          prop="areaName"
          label="行政区划"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="林业部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo1"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="住建部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo2"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="交通部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo3"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="水利部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo4"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="人社部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo5"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="其它部门"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo6"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="公益性岗位安置统计表"
      :visible.sync="centerDialogVisible"
      :modal="false"
      width="1400px"
      @close="close"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" :rules="rules" ref="editForm" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="姓名：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="所属部门：">
                          <el-select size="mini" filterable v-model="editForm.belongTo" placeholder="请选择">
                            <el-option
                              v-for="item in $public.suoshubumen"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="岗位名称：">
                          <el-input style="width:193px;" v-model="editForm.jobName"></el-input>
                        </el-form-item>
                        <el-form-item label="就业单位：">
                          <el-input style="width:193px;" v-model="editForm.workOrganization"></el-input>
                        </el-form-item>
                        <el-form-item label="上岗时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.startWorkTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="平均月薪(元)：">
                          <el-input style="width:193px;" v-model="editForm.salary"></el-input>
                        </el-form-item>
                        <el-form-item label="在岗状态：">
                          <el-input style="width:193px;" v-model="editForm.workStatus"></el-input>
                        </el-form-item>
                        <el-form-item label="退岗时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.endWorkTime"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>    
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/publicWelfareJob',
      centerDialogVisible:false,
      form:{},
      type:'8',
      tableData:[],
      tableData1:[],
      selectRow:[],
      baseInfo:[					
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},		
        {key:'name',value:'姓名'},
        {key:'idCard',value:'身份证号码'},
        {key:'phone',value:'联系电话'},
        {key:'belongTo',value:'所属部门'},
        {key:'jobName',value:'岗位名称'},
        {key:'workOrganization',value:'就业单位'},
        {key:'startWorkTime',value:'上岗时间'},
        {key:'salary',value:'平均月薪(元)'},
        {key:'workStatus',value:'在岗状态'},
        {key:'endWorkTime',value:'退岗时间'},
      ],  
      baseInfo1:[					
        {key: 'forestryEcology', value: '生态护林员'},
        {key: 'forestryOther', value: '其它'},
      ],
      baseInfo2:[					
        {key: 'buildClean', value: '保洁员'},
        {key: 'buildOther', value: '其它'},
      ],
      baseInfo3:[					
        {key: 'trafficMaintain', value: '道路维护'},
        {key: 'trafficeOther', value: '其它'},
      ],
      baseInfo4:[					
        {key: 'waterRiver', value: '河道协管'},
        {key: 'waterTakcare', value: '水库看护'},
        {key: 'waterOther', value: '其它'},
      ],  
      baseInfo5:[					
        {key: 'social', value: '人社协理'},
        {key: 'socialOther', value: '其它'},
      ],  
      baseInfo6:[					
        {key: 'otherSecurity', value: '治安协管'},
        {key: 'otherLonely', value: '孤寡老人看护'},
        {key: 'otherOther', value: '其它'},
      ],    
      rules:{
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      isCreate:false,
      out:false,
    }
  },
  created() {
    this.isShowBtn("PublicWelfareJob")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.startWorkTime = new Date(newForm.startWorkTime).getTime()
      newForm.endWorkTime = new Date(newForm.endWorkTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box{display:flex;flex-direction: row;justify-content: flex-start;}
.input-box>div{display:flex;flex-direction: column;}

</style>
